export const MuiDrawerStyles = {
    styleOverrides: {
        root: {
            '&.MuiDrawer-modal .MuiModal-backdrop': {
                background: 'rgba(247, 247, 247, 0.85)',
            },
        },
    },
};
